// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__9IT53","btnPrimary":"button_btnPrimary__Tj8eV","btnDanger":"button_btnDanger__Z1iOn","btnOutline":"button_btnOutline__lJqHA"};